import angular from 'angular';

angular.module('cloudX').directive('cxCompanyPicker', [
  '$filter',
  '$rootScope',
  'dataCache',
  function($filter, $rootScope, dataCache) {
    return {
      restrict: 'E',
      replace: true,
      scope: true,
      template: `<div>
        <tags-input
          ng-model="selected"
          placeholder="{{('Own companies'|translate)}}"
          display-property="name"
          key-property="id"
          on-tag-added="updateValue()"
          on-tag-removed="updateValue()"
          replace-spaces-with-dashes="false"
          add-from-autocomplete-only="true"
          min-length="1"
          class="bootstrap">
          <auto-complete
            source="getSuggestions($query)"
            load-on-focus="true"
            load-on-empty="true"
            display-property="name"
            max-results-to-show="25"
            min-length="0"></auto-complete>
        </tags-input>
      </div>`,
      require: 'ngModel',
      link: function($scope, el, attrs, ngModel) {
        if (!ngModel) return;
        $scope.selected = [];
        $scope.options = [];
        var findOption = function(code) {
          if (code == null || $scope.options.length === 0) return null;
          return $scope.options.find(function(el) {
            return el.id === code;
          });
        };
        $scope.options = dataCache.getArray('company');

        $scope.getSuggestions = function(search) {
          return $filter('filter')($scope.options, search);
        };

        $scope.updateValue = function() {
          ngModel.$setViewValue($scope.selected.map(x => x.id));
        };

        ngModel.$render = function() {
          var value = ngModel.$viewValue;
          if (value !== null && typeof value !== 'undefined' && angular.isArray(value)) {
            $scope.selected = value.map(x => findOption(x));
          }
        };
      },
    };
  },
]);
